"use client";

import { motion } from "framer-motion";
import { ReactNode } from "react";
import { iconHover, iconSpin, pulse, shake } from "../../lib/animations";

interface AnimatedIconProps {
  children: ReactNode;
  className?: string;
  animation?: "hover" | "spin" | "pulse" | "shake" | "none";
  onClick?: () => void;
  whileHover?: "hover" | "spin" | "pulse" | "shake";
  whileTap?: "tap" | "shake";
  initial?: "initial" | "pulse";
  animate?: "initial" | "pulse";
  variants?: any;
  custom?: any;
}

export default function AnimatedIcon({
  children,
  className = "w-6 h-6",
  animation = "hover",
  onClick,
  whileHover,
  whileTap,
  initial = "initial",
  animate,
  variants,
  custom,
}: AnimatedIconProps) {
  const getVariants = () => {
    if (variants) return variants;

    switch (animation) {
      case "spin":
        return iconSpin;
      case "pulse":
        return pulse;
      case "shake":
        return shake;
      case "hover":
      default:
        return iconHover;
    }
  };

  const getWhileHover = () => {
    if (whileHover) return whileHover;
    if (animation === "hover") return "hover";
    if (animation === "spin") return "hover";
    if (animation === "shake") return "shake";
    return undefined;
  };

  const getWhileTap = () => {
    if (whileTap) return whileTap;
    if (animation === "hover") return "tap";
    if (animation === "shake") return "shake";
    return undefined;
  };

  return (
    <motion.div
      className={className}
      onClick={onClick}
      variants={getVariants()}
      initial={initial}
      animate={animate}
      whileHover={getWhileHover()}
      whileTap={getWhileTap()}
      custom={custom}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {children}
    </motion.div>
  );
}
